<template>
    <div class="row customers">
        <div class="col-lg-12 text-center">
            <h4>{{ title }}</h4>
        </div>
        <div v-for="customer in customers" :key="customer.id" class="col-lg-4">
            <div class="card">
                <a :href="customer.href" target="_blank">
                    <img class="card-img-top" :src="customer.src" :alt="customer.title">
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Customers',
  data () {
    return {
      msg: '',
      title: 'Разработка и сопровождение корпоративного ПО на основе FreeSoftware/OpenSource.',
      customers: [
        {title: 'hardsoft321 our experience', href: '/static/files/profile_hardsoft321_main_projects.pdf', src: '/static/img/customers/our_experience_purple_480x320.png'},
        {title: 'hardsoft321 waterman3', href: 'http://www.omskvodokanal.ru', src: '/static/img/customers/omskvodokanal.png'},
        {title: 'hardsoft321 уралсиб', href: 'https://www.uralsib.ru', src: '/static/img/customers/uralsib.jpg'},
      ],
    }
  }
}
</script>

<style scoped>
  .customers .card {
    border: 1px solid rgba(0,0,0,0);
  }
  .customers .card:hover {
    border: 1px solid rgba(0,0,0,.125);
  }
</style>



// WEBPACK FOOTER //
// src/components/parts/Customers.vue